<template lang="pug">
el-dialog(
    :title="modal.title"
    :visible.sync="modal.visibility"
    :modal="true"
    width="500px"
    @close="$emit('focus-search')"
    @closed="resetRefundDialog"
)
    //- v-loading="modal.loading"
    .modal-body(
        ref="refundDialogBody"
        v-dragscroll
    )
        el-form(
            ref="form"
            :model="modal.form"
            label-position="top"
            :rules="modal.rules"
            v-loading="modal.loading"
            @submit.prevent.native="submit"
        )
            el-form-item
                template(v-for="paymentMethod in options.paymentMethod.items")
                    el-button(
                        type="primary"
                        :plain="!modal.form.paymentMethod || modal.form.paymentMethod.id != paymentMethod.id"
                        :icon="paymentMethod.digital ? 'far el-icon-fa-credit-card' : 'fas el-icon-fa-money-bill'"
                        @click="togglePaymentMethod($event, paymentMethod)"
                    ) {{ paymentMethod.name }}
                el-button.coupon-button(
                    type="primary"
                    :plain="!modal.form.coupon"
                    icon="el-icon-fa-receipt fas"
                    @click="toggleCoupon($event)"
                ) {{ $t('Coupon') }}

            transition(name="slide-decent-vertical")
                .withdrawal-fields(v-if="modal.form.paymentMethod")
                    el-form-item(:label="$t('Amount')" prop="amount")
                        el-input(type="number" v-model="modal.form.amount" step="0.01" min="0")
                            template(slot="append")
                                i.el-icon-fa-euro-sign.fas(v-if="currency.iso4217 === 'EUR'")
                                i.el-icon-fa-dollar-sign.fas(v-else-if="currency.iso4217 === 'USD'")
                                b.currency(v-else) {{ currency.sign }}
                    el-form-item(:label="$t('Comment')" prop="comment")
                        el-input(
                            type="textarea"
                            v-model="modal.form.comment"
                            :autosize="{ minRows: 3, maxRows: 8 }"
                            maxlength="255"
                            show-word-limit
                        )

    .modal-footer
        el-button(
            round
            icon="el-icon-fa-times fas"
            @click="closeRefundDialog"
        ) {{ $t('Dismiss') }}
        el-button(
            v-if="modal.form.paymentMethod || modal.form.coupon"
            round
            :disabled="modal.loading || modal.saving"
            :loading="modal.saving"
            type="primary"
            :icon="modal.form.paymentMethod ? 'el-icon-fa-check fas' : 'el-icon-fa-arrow-right fas'"
            @click="submit"
        )
            span(v-if="modal.form.paymentMethod") {{ $t('Refund') }}
            span(v-else) {{ $t('Continue') }}
</template>

<i18n>
{
    "en": {
        "Refund for: {sku}": "Refund for: {sku}"
    },
    "de": {
        "Refund for: {sku}": "Rückerstattung für: {sku}",
        "How would you like to refund": "Wie möchten Sie erstatten",
        "Withdrawal could not be saved": "Betrag konnte nicht ausgebucht werden",
        "Cash withdrawn successfully": "Betrag erfolgreich ausgebucht",
        "Coupon": "Gutschein",
        "Amount": "Betrag",
        "Comment": "Kommentar",
        "Refund": "Erstatten",
        "Continue": "Fortfahren"
    }
}
</i18n>

<script>
import uniqid from 'uniqid'
import CashFlowLogApi from '@/extensions/shop/pointOfSale/store/api/cashFlowLog';
import { useSetupStore, usePosSetupStore } from '@/stores'

export default {
    name: 'RefundDialog',
    data() {
        return {
            modal: {
                title: this.$t('How would you like to refund'),
                visibility: false,
                loading: false,
                saving: false,
                form: {
                    amount: 0,
                    paymentMethod: undefined,
                    comment: '',
                    coupon: true,
                },
                rules: {}
            },
        };
    },
    computed: {
        posSetupStore() {
            return usePosSetupStore();
        },
        activeCms() {
            return useSetupStore().activeCms;
        },
        activeShop() {
            return this.activeCms.shop;
        },
        activePointOfSale() {
            return this.posSetupStore.activePointOfSale;
        },
        currency() {
            return this.posSetupStore.currency;
        },
        options() {
            return this.posSetupStore.options;
        },
    },
    methods: {
        togglePaymentMethod(event, paymentMethod) {
            this.modal.form.coupon = false;
            if (!this.modal.form.paymentMethod || this.modal.form.paymentMethod.id !== paymentMethod.id) {
                this.$set(this.modal.form, 'paymentMethod', paymentMethod);
            } else {
                // this.$set(this.modal.form, 'paymentMethod', null);
            }

            // blur the clicked button
            event.target.blur();
        },
        toggleCoupon(event) {
            this.modal.form.paymentMethod = undefined;
            if (!this.modal.form.coupon) {
                this.$set(this.modal.form, 'coupon', true);
            } else {
                // this.$set(this.modal.form, 'coupon', false);
            }

            // blur the clicked button
            event.target.blur();
        },
        submit() {
            if (this.modal.form.paymentMethod) {
                const payload = {
                    amount: this.modal.form.amount,
                    comment: this.modal.form.comment,
                    currency: this.currency,
                    direction: 'out',
                    paymentMethod: this.modal.form.paymentMethod,
                    pointOfSale: this.activePointOfSale,
                }

                this.modal.saving = true;
                CashFlowLogApi.create(payload)
                    .finally(() => {
                        this.modal.saving = false;
                    })
                    .then(cashFlowLog => {
                        this.$notify.success({
                            title: this.$t('Cash withdrawn successfully'),
                            iconClass: 'fas el-icon-fa-check',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                        this.modal.visibility = false;
                        this.updateAutofocusSearchInput(true);
                    })
                    .catch(error => {
                        console.error(error)
                        this.$notify.error({
                            title: this.$t('Withdrawal could not be saved'),
                            iconClass: 'fas el-icon-fa-times',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                    })
            } else {
                this.$emit('create-coupon', this.modal.form.amount);
                setTimeout(() => {
                    this.closeRefundDialog();
                }, 100);
            }
        },
        openRefundDialog(data) {
            const { article, stock, price } = data

            this.modal.visibility = true;
            this.modal.form.amount = price || 0;
            this.modal.form.comment = this.$t('Refund for: {sku}', { sku: article.sku });

            this.$emit('blur-search');
            this.updateAutofocusSearchInput(false);
        },
        closeRefundDialog() {
            this.modal.visibility = false;
        },
        resetRefundDialog() {
            this.modal = {
                title: this.$t('How would you like to refund'),
                visibility: false,
                loading: false,
                saving: false,
                form: {
                    amount: 0,
                    paymentMethod: undefined,
                    comment: '',
                    coupon: true,
                },
                rules: {}
            };

            this.updateAutofocusSearchInput(true);
        },
        updateAutofocusSearchInput(value) {
            this.posSetupStore.updateAutofocusSearchInput(value);
        },
    }
}
</script>

<style lang="sass" scoped>
.modal-footer .right
    display: flex
    gap: 1rem
</style>
